import * as exElement from '../../../utils/element';

// ----------------------------------------------------------------------------

/*
 * An item that needs more than a label: a name, and a line under it saying what
 * picking it does. The markup is built here rather than handed in as html so the
 * class names the stylesheet hangs off stay the component's own.
 *
 * The title is moved into it because a link puts its own title straight into the
 * link, next to the icon, where the subtitle would have nothing to sit under.
 */
function withItemBody(config: Record<string, any>): Record<string, any> {
    if (config.subtitle == null) {
        return config;
    }

    const elBody = exElement.create({
        tag: 'span',
        class: {
            new: 'dropdown-item-body',
        },
    });

    for (const part of ['title', 'subtitle']) {
        if (config[part] == null) {
            continue;
        }

        elBody.appendChild(
            exElement.create({
                tag: 'span',
                class: {
                    new: `dropdown-item-${part}`,
                },
                html: config[part],
            }),
        );
    }

    const rest = { ...config };
    delete rest.title;
    delete rest.subtitle;

    return { ...rest, html: elBody };
}

// ----------------------------------------------------------------------------

export default withItemBody;
